import * as React from "react";

import type { ISession } from "@mne-authentication/api";

import type { ISessionCtx } from "./SessionContext";
import SessionContext from "./SessionContext";

export interface ISessionProps {
  session: ISession | null;
  loading: boolean;
  children: React.ReactNode;
  checkPermission: ISessionCtx["checkPermission"];
}

const Session = (props: ISessionProps) => {
  const { children, session, loading, checkPermission } = props;
  return (
    <SessionContext.Provider value={{ checkPermission, session, loading, initialized: true }}>
      {children}
    </SessionContext.Provider>
  );
};

export default Session;
